import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Connexion from './components/login/connexion';
import ActivationPage from './components/login/activation';
import Dashboard from './components/dashboard/dashboard';
import Admin from './components/administration/admin';
import Liste_utilisateur from './components/administration/utilisateurs/liste_utilisateur';
import Profil_utilisateur from './components/dashboard/profil';
import Liste_produit from './components/administration/produit/liste_produit';
import Ajouter_produit from './components/administration/produit/ajouter_produit';
import MotDePassePage from './components/login/mot_de_passe';
import Modifier_produit from './components/administration/produit/modifier_produit';
import Liste_groupe from './components/administration/groupe/groupe';
import Ajouter_groupe from './components/administration/groupe/ajouter_groupe';
import Modifier_groupe from './components/administration/groupe/modifier_groupe';
import Ajouter_acces from './components/administration/groupe/ajouter_acces';
import Ajouter_utilisateur_groupe from './components/administration/groupe/ajouter_utilisateur_groupe';
import Eligibilite from './components/eligibilite/form';
import Eligibilite_admin from './components/eligibilite/admin_form';
import Experience_form_admin from './components/eligibilite/admin_form_experience';
import Eligibilites_soumises from './components/eligibilite/eligibilites_soumises';
import axios from 'axios';
import LoadingSpinner from './components/login/loading';
import Liste_formation from './components/administration/formation/liste_formation';
import Ajouter_formation from './components/administration/formation/ajouter_formation';
import Modifier_formation from './components/administration/formation/modifier_formation';
import Liste_qcm from './components/administration/qcm/liste_qcm';
import Liste_eco from './components/simulation/eco/liste_eco';
import Ajouter_eco from './components/simulation/eco/ajouter_eco';
import Modifier_eco from './components/simulation/eco/modifier_eco';
import Liste_tag from './components/simulation/tag/liste_tag';
import Modifier_tag from './components/simulation/tag/modifier_tag';
import Ajouter_tag from './components/simulation/tag/ajouter_tag';
import Liste_domaine from './components/simulation/domaine/liste_domaine';
import Modifier_domaine from './components/simulation/domaine/modifier_domaine';
import Ajouter_domaine from './components/simulation/domaine/ajouter_domaine';
import Ajouter_qcm from './components/administration/qcm/ajouter_qcm';
import Historique_simulation from './components/simulation/simulateur/simulateur';
import Modifier_qcm from './components/administration/qcm/modifier_qcm';
import Liste_groupe_processus from './components/simulation/groupeprocessus/groupe_processus';
import Ajouter_groupe_processus from './components/simulation/groupeprocessus/ajouter_groupe_processus';
import Modifier_groupe_processus from './components/simulation/groupeprocessus/modifier_groupe_processus';
import Favoris from './components/simulation/simulateur/favoris';
import Demarrer from './components/simulation/simulateur/demarrer';
import Terminer from './components/simulation/simulateur/terminer';
import Historique_examen from './components/examen/examen';
import Demarrer_examen from './components/examen/demarrer_examen';
import RecapitulatifExamen from './components/examen/examen_recapitulatif';
import Resultat_examen from './components/examen/examen_resultat';
import Favoris_examen from './components/examen/Favoris_examen';
import Historique_admin from './components/examen/examen_admin';
import AccessDenied from './components/accesdenied';
import MaintenancePage from './components/maintenance';
import Liste_diffusion from './components/administration/listediffusion/liste_diffusion';
import Ajouter_diffusion from './components/administration/listediffusion/ajouter_diffusion';
import Modifier_diffusion from './components/administration/listediffusion/modifier_diffusion';
import Ajouter_utilisateur_diffusion from './components/administration/listediffusion/ajouter_utilisateur_diffusion'; import ListeNotification from './components/administration/Notification/notification';
import Liste_notification from './components/administration/Notification/notification';
import Parcours from './components/administration/parcours/parcours';
import Liste_parcours from './components/administration/parcours/parcours_admin';
import Configuration_parcours from './components/administration/parcours/configuration_parcours';
import Liste_etude from './components/etudedecas/liste_etude';
import Etude_de_cas from './components/etudedecas/etude_de_cas';
import Resultat_etude from './components/etudedecas/etude_resulltat';
import Etude_demarrer from './components/etudedecas/demarrer_etude';
import Demarrer_qcm from './components/dashboard/demarrer_qcm';
import Liste_dictionnaire from './components/Dictionnaire/dictionnaire';
import Demarrer_jeux from './components/Dictionnaire/demarrer_jeux';
import Configurer_groupe from './components/administration/groupe/configurer_groupe';
import Terminer_jeux from './components/Dictionnaire/terminer_jeux';
import Resulat_qcm from './components/dashboard/terminer_qcm';
import Historique_evaluation from './components/administration/parcours/historique';
import Quiz_form from './components/Dictionnaire/quiz_form';
import Resultat_examen_admin from './components/examen/resultats_examen_admin';
import Abonnements from './components/administration/produit/abonnements';
import Paiement_reussi from './components/administration/produit/paiement_reussi';
import Defaillants from './components/administration/qcm/defaillants';
import Partenaire from './components/administration/partenaire/listePartenaire';
import PartenairePage from './components/administration/partenaire/page_partenaire';
import DevenirPartenaire from './components/login/devenirPartenaire';
import ListePartenaire from './components/administration/partenaire/listePartenaire';
import ListeSouscriptions from './components/souscription/souscription_utilisateur';
import ListeSouscriptionsAdmin from './components/souscription/souscription_admin';
import SouscrirePage from './components/souscription/souscrirePage';
import JournalPaiementUtilisateur from './components/souscription/journalPaiement';
import Journalisation from './components/administration/journalisation';
import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import LinkedInRediction from './components/login/linkedin';
import GestionRendezVousAdmin from './components/RDV/rdvAdmin';
import PriseRendezVousClient from './components/RDV/priseDeRDV';
import NewsLetters from './components/administration/Notification/newsLetters';
import Historique_unifie from './components/simulation/fusion_simulateur_examen_blanc';
import Demarrer_examen_refonte from './components/simulation/demarer_examen_refonte';
import Resultat_examen_refonte from './components/simulation/examen_resultats_refonte';
import ConfirmationDesabonnement from './components/administration/Notification/confirmationDesabonnement';
import EmailInvalide from './components/administration/Notification/emailInvalide';
import ProfileSelection from './components/login/profileSelection';
import ActivationCoach from './components/login/activationCoach';
import Resultat_principe from './components/simulation/resultats_principe';
import BookingsCoach from './components/RDV/BookingCoach';
import Gestion_avis_client from './components/administration/avis_client/GestionAvisQuestions';
import FormulaireAvisClient from './components/administration/avis_client/FormulaireAvisClient';
// import Inscription from './components/login/inscription';
import ListeInscriptions from './components/administration/utilisateurs/liste_inscription';
import Liste_Specialite from './components/administration/formation/liste_specialite';
import FAQ from './components/dashboard/faq';
import Liste_situation from './components/administration/misesituation/liste_situation';
// import Liste_qcm_en from './components/administration/qcm/liste_qcm_en';




function App() {
  const user_id = localStorage.getItem('user_id');
  const groupe = localStorage.getItem('groupe');
  const acces = localStorage.getItem('accesGroupe');
  const [accesGroupe, setAccesGroupe] = useState([]);
  const [loading, setLoading] = useState(true); // Un état pour savoir si la vérification est terminée
  // const [utilisateurId, setUtilisateurId] = useState();
  // const [groupeId, setGroupeId] = useState();


  // useEffect(() => {
  //   if (!user_id) {
  //     window.location.reload();
  //     const user_id = localStorage.getItem('user_id');
  //     const groupe = localStorage.getItem('groupe');
  //     setUtilisateurId(user_id)
  //     setGroupeId(groupe)
  //   }
  // }, []);

  // Fetch user access rights une seule fois au chargement
  const fetchAccessRights = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
      const data = response.data;
      // setAccesGroupe(data.acces[0].acces); // Mettre à jour les accès

      let cleanedAccessArray = [];
      if (Array.isArray(data.acces)) {
        cleanedAccessArray = data.acces.map((item) =>
          item.acces
            ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
            : []
        ).flat();

        setAccesGroupe(cleanedAccessArray);
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des accès:', error);
    } finally {
      setLoading(false); // Fin de la vérification
    }
  };

  useEffect(() => {
    fetchAccessRights();
  }, [user_id]);

  if (loading) {
    // Affiche un écran de chargement pendant la vérification
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100vw', 
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundColor: '#f8f9fa' // Optionnel : fond léger
        }}>
            <div className="spiner-example">
                <div className="sk-spinner sk-spinner-wave">
                    <div className="sk-rect1 mr-1"></div>
                    <div className="sk-rect2 mr-1"></div>
                    <div className="sk-rect3 mr-1"></div>
                    <div className="sk-rect4 mr-1"></div>
                    <div className="sk-rect5"></div>
                </div>
            </div>
        </div>
    );
  }

  const userHasAccess = (accessKey) => {

    if (!acces) {
      return false;
    }

    // Vérifie si l'utilisateur a l'accès spécifié
    return accesGroupe && acces.includes(accessKey);
  };


  return (
    <Router>
      <Routes>
        <Route path="/" element={<Connexion />} />
        <Route path="/linkedin" element={<LinkedInRediction />} />
        <Route path="/Selection-profile" element={<ProfileSelection />} />
        <Route path="/activation-page" element={<ActivationPage />} />
        <Route path="/activation-coach" element={<ActivationCoach />} />
        <Route path="/mot-de-passe" element={<MotDePassePage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/Profil-utilisateur" element={<Profil_utilisateur />} />
        <Route path="/admin" element={<Admin />} />

        <Route path="/Liste-utilisateur" element={<Liste_utilisateur />} />
        <Route path="/Liste-partenaire" element={<ListePartenaire />} />
        <Route path="/Page-partenaire" element={<PartenairePage />} />
        <Route path="/Devenir-partenaire" element={<DevenirPartenaire />} />
        <Route path="/Liste-produit" element={<Liste_produit />} />
        <Route path="/Ajouter-produit" element={<Ajouter_produit />} />
        <Route path="/Modifier-produit" element={<Modifier_produit />} />
        <Route path="/Liste-groupe" element={<Liste_groupe />} />
        <Route path="/Ajouter-groupe" element={<Ajouter_groupe />} />
        <Route path="/Modifier-groupe" element={<Modifier_groupe />} />
        <Route path="/Configurer-groupe" element={<Configurer_groupe />} />
        <Route path="/ajouter-utilisateur-groupe" element={<Ajouter_utilisateur_groupe />} />
        <Route path="/Ajouter-acces/:groupe_id" element={<Ajouter_acces />} />
        <Route path="/Eligibilite-admin" element={<Eligibilite_admin />} />
        <Route path="/Experience-form-admin" element={<Experience_form_admin />} />
        <Route path="/Eligibilites-soumises" element={<Eligibilites_soumises />} />
        <Route path="/Liste-formation" element={<Liste_formation />} />
        <Route path="/Ajouter-formation" element={<Ajouter_formation />} />
        <Route path="/Modifier-formation" element={<Modifier_formation />} />
        <Route path="/Liste-qcm" element={<Liste_qcm />} />
        <Route path="/Qcm-defaillants" element={<Defaillants />} />
        <Route path="/Ajouter-qcm" element={<Ajouter_qcm />} />
        <Route path="/Modifier-qcm" element={<Modifier_qcm />} />
        <Route path="/Liste-eco" element={<Liste_eco />} />
        <Route path="/Ajouter-eco" element={<Ajouter_eco />} />
        <Route path="/Modifier-eco" element={<Modifier_eco />} />
        <Route path="/Liste-tag" element={<Liste_tag />} />
        <Route path="/Modifier-tag" element={<Modifier_tag />} />
        <Route path="/Ajouter-tag" element={<Ajouter_tag />} />
        <Route path="/Liste-domaine" element={<Liste_domaine />} />
        <Route path="/Modifier-domaine" element={<Modifier_domaine />} />
        <Route path="/Ajouter-domaine" element={<Ajouter_domaine />} />
        <Route path="/Liste-groupe-processus" element={<Liste_groupe_processus />} />
        <Route path="/Ajouter-groupe-processus" element={<Ajouter_groupe_processus />} />
        <Route path="/Modifier-groupe-processus" element={<Modifier_groupe_processus />} />
        <Route path="/simulateur" element={<Historique_simulation />} />
        <Route path="/Favoris" element={<Favoris />} />
        <Route path="/Demarrer" element={<Demarrer />} />
        <Route path="/Terminer" element={<Terminer />} />
        <Route path="/Historique-examen" element={<Historique_examen />} />
        <Route path="/Examen-favoris" element={<Favoris_examen />} />
        <Route path="/demarrer-examen" element={<Demarrer_examen />} />
        <Route path="/resultat-examen" element={<Resultat_examen />} />
        <Route path="/Gestion-des-examens" element={<Historique_admin />} />
        <Route path="/Recapitulatif-examen" element={<RecapitulatifExamen />} />
        <Route path="/Admin-Resultat-examen" element={<Resultat_examen_admin />} />
        <Route path="/Liste-notification" element={<Liste_notification />} />
        <Route path="/Liste-dictionnaire" element={<Liste_dictionnaire />} />
        <Route path="/Quizz-form" element={<Quiz_form />} />
        <Route path="/Quizz-demarrer" element={<Demarrer_jeux />} />
        <Route path="/Quizz-terminer" element={<Terminer_jeux />} />
        <Route path="/Liste-diffusion" element={<Liste_diffusion />} />
        <Route path="/Ajouter-diffusion" element={<Ajouter_diffusion />} />
        <Route path="/Modifier-diffusion" element={<Modifier_diffusion />} />
        <Route path="/Ajouter-utilisateur-diffusion" element={<Ajouter_utilisateur_diffusion />} />
        <Route path="/Liste-etude" element={<Liste_etude />} />
        <Route path="/Etude-de-cas" element={<Etude_de_cas />} />
        <Route path="/Etude-demarrer" element={<Etude_demarrer />} />
        <Route path="/Resultats-etude" element={<Resultat_etude />} />
        <Route path="/eligibilite" element={<Eligibilite />} />
        <Route path="/Parcours" element={<Parcours />} />
        <Route path="/Historique-evaluation" element={<Historique_evaluation />} />
        <Route path="/demarrer-qcm" element={<Demarrer_qcm />} />
        <Route path="/terminer-qcm" element={<Resulat_qcm />} />
        <Route path="/Souscription-utilisateur" element={<ListeSouscriptions />} />
        <Route path="/Souscrire" element={<SouscrirePage />} />
        <Route path="/Liste-souscription-admin" element={<ListeSouscriptionsAdmin />} />
        <Route path="/Journal-paiement" element={<JournalPaiementUtilisateur />} />
        <Route path="/RDV-admin" element={<GestionRendezVousAdmin />} />
        <Route path="/Booking-coach" element={<BookingsCoach />} />
        <Route path="/prise-de-RDV" element={<PriseRendezVousClient />} />
        <Route path="/NewsLetters" element={<NewsLetters />} />
        <Route path="/Historique-complet" element={<Historique_unifie />} />
        <Route path="/Lancement-examen" element={<Demarrer_examen_refonte />} />
        <Route path="/Fin-examen" element={<Resultat_examen_refonte />} />
        <Route path="/Resultats-principe" element={<Resultat_principe />} />


        <Route path="/Liste-parcours" element={<Liste_parcours />} />
        
        <Route path="/Configuration-parcours" element={<Configuration_parcours />} />
        <Route path="/Gestion-avis-client" element={<Gestion_avis_client />} />
        <Route path="/Formulaire-avis-client" element={<FormulaireAvisClient />} />


        <Route path="/Maintenance" element={<MaintenancePage />} />
        <Route path="/Journalisation" element={<Journalisation />} />

        <Route path="/desabonner/" element={<ConfirmationDesabonnement />} />
        <Route path="/FAQ" element={<FAQ />} />
        <Route
          path="/email-invalide"
          element={<EmailInvalide />}
        />

        <Route path="/Liste-situation" element={<Liste_situation />} />

        
        {/* <Route path="/Inscription/" element={<Inscription />} /> */}
        <Route path="/Liste-inscription" element={<ListeInscriptions />} />
        <Route path="/Liste-specialite" element={<Liste_Specialite />} />
      </Routes>
    </Router>
  );
}
export default App;
